import HTTP from '@/api/HTTP';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import {
  TYPE_VENTE, TYPE_ACHAT, TYPE_REGLEMENT, TYPE_PAIEMENT,
  TYPE_OD,
} from '@/configuration/compta/ecritureConf';
import { SENS_ACHAT } from '@/configuration/devisConf';

const URL_BASE = 'gescom/IfEcriture/';

export async function getAll(search) {
  const inputServer = generalTransformer(search);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function insertIntoIfLot(input) {
  const response = await HTTP.post(URL_BASE + 'InsertIntoIfLotAsync', input);
  return response;
}

export async function getByRemiseBancaire(idRemiseBancaire, sens) {
  const typeEcriture = sens === SENS_ACHAT ? TYPE_PAIEMENT : TYPE_REGLEMENT;
  const response = await HTTP.get(URL_BASE + 'GetByReferencePieceAsync', {
    params: {
      ReferencePieceId: idRemiseBancaire,
      TypeEcriture: typeEcriture,
    },
  });
  return response;
}

export async function getByFacture(idDevisCommande, sens) {
  let typeEcr = TYPE_VENTE;
  if (sens === SENS_ACHAT) typeEcr = TYPE_ACHAT;
  const response = await HTTP.get(URL_BASE + 'GetByReferencePieceAsync', {
    params: {
      ReferencePieceId: idDevisCommande,
      TypeEcriture: typeEcr,
    },
  });
  return response;
}

export async function getByOperationDiverse(idOperationDiverse) {
  const response = await HTTP.get(URL_BASE + 'GetByReferencePieceAsync', {
    params: {
      ReferencePieceId: idOperationDiverse,
      TypeEcriture: TYPE_OD,
    },
  });
  return response;
}

export async function generateByFacture(idDevisCommande, sens) {
  const response = await HTTP.post(URL_BASE + 'PRegenerateByReferencePieceAsync', {
    ReferencePieceId: idDevisCommande,
    TypeEcriture: sens,
  });
  return response;
}

export async function generateByRemiseBancaire(params) {
  const response = await HTTP.post(URL_BASE + 'PRegenerateByReferencePieceAsync', params);
  return response;
}

export async function generateByOperationDiverse(params) {
  const response = await HTTP.post(URL_BASE + 'PRegenerateByReferencePieceAsync', params);
  return response;
}

export async function deleteEcriture(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}
